import { Flex } from '@/components'
import styled from 'styled-components'

export const DialogOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
  animation: fadeIn 0.2s ease-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`

export const DialogContainer = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  width: 90%;
  max-width: 70vw;
  animation: slideIn 0.3s ease-out;
  position: relative;

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(-20px) scale(0.95);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
`

export const ModalHeaderContainer = styled(Flex)`
  justify-content: space-between;

  h1 {
    margin: 30px;
    margin-bottom: 10px;
  }

  button {
    margin: 20px;
    margin-bottom: 10px;
  }
`

export const ModalBody = styled.form`
  all: unset;
  border-radius: 20px;
  padding: 40px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  gap: 40px;
  background-color: #fff;
  overflow-y: scroll;
  height: 70vh;
`
